import { combineReducers } from 'redux';
import mapValues from 'lodash/mapValues';

import * as C from '../constants/merchantTypes';
import { FETCH_DOCUMENT_CATEGORY_AND_TYPES_SUCCESS } from '../constants/documentTypes';

/**
 * business entity reducer responsible for fething business registration type
 * @param  {object} state  initial state
 * @param  {object} action redux action object
 * @return {object}        redux store state
 */
export function businessEntityReducer(state = [], action) {
  switch (action.type) {
    case C.FETCH_BUSINESS_ENTITIES_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}

export function businessCategoryReducer(state = [], action) {
  switch (action.type) {
    case C.FETCH_BUSINESS_CATEGORIES_SUCCESS:
    return action.payload;
    default:
    return state;
  }
}

export function resellerBusinessCategoryReducer(state = [], action) {
    switch (action.type) {
      case C.FETCH_RESELLER_BUSINESS_CATEGORIES_SUCCESS:
      return action.payload;
      default:
      return state;
    }
  }
  

/**
 * ifsc reducer for fetching ifsc code from bank details
 * @param  {object} state  initial state
 * @param  {object} action redux action object
 * @return {object}        redux store state
 */
export function ifscDetailsReducer(
    state = {
        bankNames: [],
        bankStates: [],
        bankCities: [],
        bankBranchesIfscDetails: [],
    },
    action,
) {
    switch (action.type) {
        case C.FETCH_BANK_NAMES_FOR_IFSC_SUCCESS:
            return {
                ...state,
                bankNames: action.payload.bank_names,
            };
        case C.FETCH_BANK_CITIES_FOR_IFSC_SUCCESS:
            return {
                ...state,
                bankCities: action.payload.cities,
            };
        case C.FETCH_BANK_STATES_FOR_IFSC_SUCCESS:
            return {
                ...state,
                bankStates: action.payload.states,
            };
        case C.FETCH_BANK_BRANCHES_FOR_IFSC_SUCCESS:
            return {
                ...state,
                bankBranchesIfscDetails: action.payload.ifsc_details,
            };
        default:
            return state;
    }
}



export function documentCategoryAndTypesReducer(
    state = {
        documentCategories: {},
        documentTypes: {},
    },
    action,
) {
    switch (action.type) {
        case FETCH_DOCUMENT_CATEGORY_AND_TYPES_SUCCESS:
            return {
                ...state,
                documentCategories: mapValues(
                    action.payload.document_categories,
                    cat => cat.id,
                ),
                documentTypes: mapValues(action.payload.document_types, typ => typ.id),
            };
        default:
            return state;
    }
}



/**
 * Called on Onboarding (profile page)
 * @param  {dispatch} redux action dispatcher func
 * @param  {param} params in case of api params
 * @return {Promise} server response
 */
export async function verifyPenny(dispatch, merchantUuid, params) {
    try {
        const response = await RestClient.post(
            `${API_ENDPOINTS.ONBOARDING.VERIFY_PENNY({ uuid: merchantUuid })}`,
            params,
        );
        return response;
    } catch (e) {
        const body = await e.response;
        throw { message: body };
    }
}

export default combineReducers({
  businessEntities: businessEntityReducer,
  businessCategories: businessCategoryReducer,
  ifscDetails: ifscDetailsReducer,
  documentCategoryAndTypes: documentCategoryAndTypesReducer,
  resellerBusinessCategories: resellerBusinessCategoryReducer,
});
